import React from "react";
import { Text, View, Image } from "react-native";
import { AppImages } from "../../utility/AppImages";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { AppColors } from "../../utility/AppColors";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { CommonButton } from "../../common/CommonButton";
import { GameShow } from "../../utility/types/gameShowTypes";

type RemainingCostModalComponentProps = { styles?: any , details?: GameShow };

const RemainingCostModalComponent: React.FC<
  RemainingCostModalComponentProps
> = ({ styles , details }) => {
  const deviceSize = useDeviceSize();

  return (
    <>
      <View
        style={{
          flexDirection: "row",
          gap: 20,
          paddingHorizontal: 10,
        }}
      >
        <Image
          source={AppImages.whiteCircle}
          style={{
            height: 25,
            width: 23,
            resizeMode: "contain",
          }}
        />
        <View>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_15,
              {
                color: AppColors.white,
              },
            ]}
          >
            Cover the Remaining Cost:
          </Text>
          <Text
            style={[
              AppFontStyle.REGULAR_ANYBODY_10,
              {
                color: AppColors.gray_6E90B4,
                paddingTop: 10,
                width:
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.XS
                    ? "40%"
                    : "100%",
              },
            ]}
          >
            You can cover the shortfall with an additional 10% handling fee.
            This ensures the event goes ahead as planned.
          </Text>
        </View>
      </View>
      <View style={styles.benefitsData}>
        <View style={styles.remainCost}>
          <CommonButton
            title="Remaining Cost + 10 % Handling Fee: 367 Tokens"
            onTap={() => {}}
            buttonStyle={styles.remainCostBtn}
            textStyle={[
              AppFontStyle.BOLD_ANYBODY_12,
              {
                color: AppColors.gray_C3C3C3,
              },
            ]}
          />

          <CommonButton
            title="Deduct From my Account"
            onTap={() => {}}
            buttonStyle={styles.optionBtnStyle}
            textStyle={[AppFontStyle.BOLD_ANYBODY_8, { textAlign: "center" }]}
          />

          <View>
            <Text
              style={[
                AppFontStyle.REGULAR_ANYBODY_14,
                {
                  color: AppColors.white,
                  fontWeight: 700,
                  textAlign:
                    deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM
                      ? "center"
                      : "auto",
                },
              ]}
            >
              Token balance
            </Text>
            <Text
              style={[
                styles.tokenPrice,
                {
                  textAlign:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? "center"
                      : "auto",
                },
              ]}
            >
            {details?.totalCredits}
            </Text>
            <CommonButton
              title="Buy tokens"
              onTap={() => {}}
              buttonStyle={styles.buyTokenBtn}
              textStyle={[AppFontStyle.BOLD_ANYBODY_12, {}]}
            />
          </View>
        </View>
      </View>
    </>
  );
};

export default RemainingCostModalComponent;
